import type { GridCell, ScreenDirection, ScreenPositions } from "../types";

type Axis = {
  along: (cell: GridCell) => number;
  across: (cell: GridCell) => number;
};

const ROW_AXIS: Axis = {
  along: (cell) => cell.row,
  across: (cell) => cell.col,
};
const COL_AXIS: Axis = {
  along: (cell) => cell.col,
  across: (cell) => cell.row,
};

const DIRECTIONS: Record<ScreenDirection, { axis: Axis; sign: 1 | -1 }> = {
  up: { axis: ROW_AXIS, sign: -1 },
  down: { axis: ROW_AXIS, sign: 1 },
  left: { axis: COL_AXIS, sign: -1 },
  right: { axis: COL_AXIS, sign: 1 },
};

type Candidate = {
  id: number;
  offset: number;
  distance: number;
  across: number;
};

const byNearest = (a: Candidate, b: Candidate) =>
  a.offset - b.offset || a.distance - b.distance || a.across - b.across;

export const screensInDirection = (
  positions: ScreenPositions,
  fromScreenId: number,
  direction: ScreenDirection,
): number[] => {
  const from = positions[fromScreenId];
  if (!from) return [];

  const { axis, sign } = DIRECTIONS[direction];

  return Object.entries(positions)
    .map(
      ([id, cell]): Candidate => ({
        id: Number(id),
        distance: (axis.along(cell) - axis.along(from)) * sign,
        offset: Math.abs(axis.across(cell) - axis.across(from)),
        across: axis.across(cell),
      }),
    )
    .filter((candidate) => candidate.distance > 0)
    .sort(byNearest)
    .map((candidate) => candidate.id);
};
